import { modalFn } from '@softline/ui-core';
import { EinheiteneingabeModalComponent } from '../einheiteneingabe/modal/einheiteneingabe-modal.component';
import { EinheiteneingabeParams } from './types/params';
import { Injector, Signal, TemplateRef } from '@angular/core';

export interface UnitEntryModalParams {
  title?: string;
  text?: string;
  subtitle?: string;
  template?: TemplateRef<any> | Signal<TemplateRef<any> | null>;
  templateContext?: unknown | Signal<unknown | null>;
  class?: string;
  priority?: number;
  dismiss?: boolean;
  injector?: Injector;
  params: EinheiteneingabeParams | Signal<EinheiteneingabeParams>;
}

export function unitEntryModalFn() {
  const modal = modalFn();
  return (options: UnitEntryModalParams) => {
    return modal({
      title: options?.title ?? 'Einheiteneingabe',
      subtitle: options?.subtitle,
      text: options?.text,
      dismiss: options?.dismiss ?? true,
      template: options?.template,
      templateContext: options?.templateContext,
      priority: options?.priority,
      class: options?.class,
      injector: options?.injector,
      component: EinheiteneingabeModalComponent,
      data: {
        params: options.params,
      },
    });
  };
}
